import 'core-js/stable';
import 'regenerator-runtime/runtime';
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    if (typeof start !== "number") {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

const useDebug =
  window.location.href.indexOf("127.0.0.1") >= 0 ||
  window.location.href.indexOf("localhost") >= 0;

import VueRaven from "vue-raven";

if (!useDebug)
  Vue.use(VueRaven, {
    dsn: "https://f46ea120dde0418e989c2ca368878954@sentry.wizmacau.com/101",
  });

import Vue from 'vue'
import VueRouter from 'vue-router'


import store from './store'

import App from './App.vue'
import Main from './view/Main.vue'
import Thankyou from './view/Thankyou.vue'
import Attendee from './view/Attendee.vue'
import ErrorDialog from "./view/ErrorDialog.vue";
import StopDialog from "./view/StopDialog.vue";


import './assets/tailwind.css';

import VueFormulate from '@braid/vue-formulate'
import { pt } from '@braid/vue-formulate-i18n'
import zh_hant from "./utils/vue-formulate-i18n-zh-hant";
import zh_hans from "./utils/vue-formulate-i18n-zh-hans";

import i18n from "./libs/i18n"


import { verifyCode , verifyCaptchaCode} from "./api/fetchEvent";

import FormulateHTML from './components/formulate-html'
Vue.component('FormulateHTML', FormulateHTML);

// /* use font awsome*/
// import { library } from "@fortawesome/fontawesome-svg-core";
// import { faShare } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// library.add(faShare);
// Vue.component("font-awesome-icon", FontAwesomeIcon);


import HTMLAllowedCustomLabel from "./components/HTMLAllowedCustomLabel.vue";

Vue.component("HTMLAllowedCustomLabel", HTMLAllowedCustomLabel);



window.VueFormulate = VueFormulate;
let $vue = null;
window.$vue=null
let tagi=1
Vue.use(VueFormulate, {
  library:{
    html:{
      classification: 'html',
      component: 'FormulateHTML',
      slotProps: {
        component: ['html']
      }
    },

  },
  plugins: [zh_hant,zh_hans , pt],
  validationNameStrategy: ["validationName", "label", "name", "type"],
  rules: {
    async verifyCodeRule(context, verifiyKeyField, verifiyCodeField, isCaptcha) {
      if(window.$vue) window.$vue.$emit("verifyCodeRule");
      let c = context.getFormValues();
      let id = c[verifiyKeyField];
      let inputVerifyCode = c[verifiyCodeField];
      console.log("verifyCodeRule", {
        context,
        c,
        id,
        verifiyKeyField,
        verifiyCodeField,
        inputVerifyCode,
        isCaptcha
      });
      if (id && inputVerifyCode) {
        try {
          window.captchaMessage = ''
          let verifyCodeResp = isCaptcha
            ? await verifyCaptchaCode(id, context.value)
            : await verifyCode(id, context.value);
          console.log({ verifyCodeResp });
       window.captchaExpired = verifyCodeResp.expired;
       if (window.captchaExpired) {
         if (window.$vue) window.$vue.$emit("refreshCaptcha");
       }
          window.captchaMessage = verifyCodeResp.message == 'OK' ? false : verifyCodeResp.message
          

          return verifyCodeResp.data;
     } catch (e) {
       window.eee = e
       return false
        }
     
      } else {
        return false;
      }
    },

  },
  classes: {
    labelHasValue: 'has-value',
    labelHasErrors: 'has-errors',
    elementHasValue : 'element-has-value',
    inputHasValue : 'input-has-value',
    wrapper(context){
      let cls = ['formulate-input-wrapper'];
      if (context.classification=='box' && context.type=='radio') {
        cls.push(`relative border border-gray-200 p-2 md:p-4 flex`);
      }
      return cls
    },
    outer(context) {
      //console.log(context);
      let cls = ["mb-4"];
      if (context.name) {
        cls.push(`name_${context.name}`);
      }
      if (context.attrs && context.attrs.wrapper_hidden) {
        cls.push(`hidden`);
      }
      return cls.join(' ');
    },
    element(context) {
      // console.log('tagi'+ ++tagi,context)
      // console.log('options tagi'+ tagi,context.options)
      // console.log('value tagi'+ tagi,context.value)
    
      
      if (context.type == "radio" || context.type == "checkbox" ) {
        return 'ttag ttagi'+tagi+" inline" +  ( context.attrs.groupCount ? ` gc-${context.attrs.groupCount}` : '' );
      }
    },
    input(context) {

      if (context.type == "radio" ) {
        return "";
      }
      if (context.type == "checkbox") {
        return " form-checkbox color-checkbox";
      }
      switch (context.classification) {
        case "button":
          if (context.type == "submit") {
            return "oundedf-full py-3 px-16 bg-yellow-500 text-white";
          }
          return "px-4 py-2 rounded bg-blue-500 text-white hover:bg-blue-600 disabled:opacity-50";
        default:
          return "border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1";
      }
    },
    label(context) {
      //console.log('label-context-'+context.name,{context})
     // console.log('tagi'+ ++tagi,context)

      if(context.type=='radio' ){
        if(context.attrs.hasValue )
          return 'tagi'+tagi+' font-medium text-base mx-1'+ (context.attrs.disabled ? " text-gray-300" : "")
        else 
          return 'tagi'+tagi+" font-medium text-base mx-1" + (context.attrs.disabled ? " text-gray-300" : "")
      }
      return (
        'tagi'+tagi+" font-medium text-base" + (context.attrs.disabled ? " text-gray-300" : "")
      );
    },
    help: "text-sm mb-1 text-gray-600",
    error: "text-red-700 text-sm mb-1",
  },
  slotComponents: {
    label: "HTMLAllowedCustomLabel"
  }
   
});


Vue.use(VueRouter)
const routes = [
  { path: "/", component: Main },
  { path: "/done/:uuid", component: Thankyou },
  { path: "/attendee/:uuid", component: Attendee },
  { path: "/error/:type", component: ErrorDialog },
  { path: "/error", component: ErrorDialog },
  { path: "/display/:key", component: StopDialog },
];
// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes // short for `routes: routes`
})


Vue.config.productionTip = false

window.$store = store;
window.$vue = $vue = new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
})
$vue.$mount("#app");